'use client'

import { useEffect } from 'react'

export function ServiceWorkerRegister() {
  useEffect(() => {
    // Only register in production
    if (process.env.NODE_ENV !== 'production') return
    
    // Check if service workers are supported
    if (!('serviceWorker' in navigator)) return

    // Register the service worker
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Check for updates periodically
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available - could show update prompt here
                console.log('New version available')
              }
            })
          }
        })
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error)
      })
  }, [])

  return null
}
